import upperFirst from 'lodash/upperFirst';
import words from 'lodash/words';

/**
 * Переводит строки в ПаскальКейс. Немного отличается от capitalize + camelCase, так как
 * camelCase сначала переводит все буквы в нижний регистр.
 * BodyText -> BodyText
 * body-text -> BodyText
 * bodytext -> Bodytext
 * @param text строка
 */
export const pascalize = (text = '') =>
    words(text)
        .map(word => upperFirst(word))
        .join('');
